import React from 'react';
import { reportNumberFormat, REPORT_AMOUNT_CLASS } from './reportFormat';

/** Indian-formatted amount string for report tables (2 decimals, en-IN grouping). */
export function fmtAmount(value) {
  return reportNumberFormat(value, { empty: '' });
}

/** Right-aligned table cell for numeric report values. */
export function NumTd({ value, className = '', children }) {
  return (
    <td className={[REPORT_AMOUNT_CLASS, className].filter(Boolean).join(' ')}>
      {children ?? fmtAmount(value)}
    </td>
  );
}

/** Right-aligned table header for numeric columns. */
export function NumTh({ children, className = '', ...props }) {
  return (
    <th
      className={[REPORT_AMOUNT_CLASS, 'report-amount-header', className].filter(Boolean).join(' ')}
      {...props}
    >
      {children}
    </th>
  );
}
